<app-page>
  <div class="col-12 xl:col-10 m-auto px-3 mt-8 md:border-round-3xl h-full p-8 bg-slate-50">
    <div class="content md:px-4 flex flex-column align-items-center">
      <ng-container *ngFor="let content of pageContent; let i = index; trackBy: trackByIndex">
        <ng-container *ngIf="content.errorCode == 400">
          <h1 class="text-2xl md:text-4xl text-slate-800">{{content.errorHeader}}</h1>

          <ng-container *ngIf="content.subheaderText">
            <h4 class="text-1xl md:text-2xl text-slate-800 custom-bold" [innerHTML]="content.subheaderText"></h4>
          </ng-container>

        </ng-container>
      </ng-container>
      <div class="flex flex-column md:flex-row md:w-5 w-full gap-3 md:gap-4">
        <p-button type="button" [rounded]="true" severity="primary" data-auto-id="login"
          class="flex align-items-center justify-content-center w-full" styleClass="w-full"
          (click)="navigateToLogin()">
          Login
        </p-button>
        <p-button type="button" severity="secondary" [rounded]="true" data-auto-id="contact-cinch" variant="outlined"
          class="flex align-items-center justify-content-center w-full" styleClass="w-full"
          (click)="navigateToContactUs()">
          Contact us
        </p-button>
      </div>
    </div>
  </div>
</app-page>